import { render } from "./billing-groups.vue?vue&type=template&id=784fcc06&scoped=true"
import script from "./billing-groups.vue?vue&type=script&lang=js"
export * from "./billing-groups.vue?vue&type=script&lang=js"

import "./billing-groups.vue?vue&type=style&index=0&id=784fcc06&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784fcc06"]])

export default __exports__